import { ProjectDto } from '@/core';
import { TableTypesEnum } from '../../Projects.Constructor.Tables/hooks';

export const findEpicNameById = (epicId: string, projectData: ProjectDto) => {
  return projectData.epics.find((x) => x.id === epicId)?.name;
};

export const findTableNameById = (tableId: string, projectData: ProjectDto) => {
  return projectData.tables.find((x) => x.id === tableId)?.name ?? '';
};

export const findTableTypeById = (tableId: string, project: ProjectDto) => {
  return project.tables.find((x) => x.id === tableId)?.type;
};

export const filterTablesByType = (projectData: ProjectDto, type: string, pickedTables?: string[]) =>
  pickedTables?.filter((table) => findTableTypeById(table, projectData) === type) ?? [];

export const getIsTableMain = (tableId: string, projectData: ProjectDto) =>
  findTableTypeById(tableId, projectData) === TableTypesEnum.Main;

export const validateSheetsTab = (projectData: ProjectDto) =>
  !projectData.sheets.some(
    (sheet) =>
      !sheet.epics.length ||
      !sheet.tables.filter((table) => getIsTableMain(table.tableId, projectData)).length,
  );

export enum MainTablesErrors {
  More = 'More',
  None = 'None',
}

export const validateMainTables = (tableIds: string[], projectData: ProjectDto) => {
  const validQuantityOfMainTables = 1;
  const mainTablesQuantity = tableIds.filter(
    (table) => findTableTypeById(table, projectData) === TableTypesEnum.Main,
  ).length;

  return mainTablesQuantity === validQuantityOfMainTables
    ? ''
    : mainTablesQuantity > validQuantityOfMainTables
    ? MainTablesErrors.More
    : MainTablesErrors.None;
};
